import {EconomicGroup} from "./../../models/EconomicGroup";
import {WrapperFactory} from "../WrapperFactory";

let economicGroupsApi = {
    async get(token, companyId,params={}){
        let response = await window.axios.get('/api/economic-groups', {
            params:{
                api_token:token,
                company_logged:companyId,
                ...params
            }
        });

        // let wrapper = WrapperFactory.fromResponse(response.data)
        // wrapper.transform(e=>new EconomicGroup(e));
        // return wrapper;

        return response.data;
    },
    async find(id, token, companyId, params={}){
        let response = await window.axios.get('/api/economic-groups/'+id, {
            params:{
                api_token:token,
                company_logged:companyId,
                ...params
            }
        });
        return response.data;
    },
    async create(economicGroup, token, companyId, params = {}){
        let response = await window.axios.post('/api/economic-groups', economicGroup, {
            params:{
                api_token:token,
                company_logged:companyId,
                ...params
            }
        });
        return new EconomicGroup(response.data);
    },
    async edit(economicGroup, token, companyId){
        let response = await window.axios.put('/api/economic-group/'+economicGroup.id, economicGroup, {
            params:{
                api_token:token,
                company_logged:companyId,
            }
        });
        return new EconomicGroup(response.data);
    }
}

export default economicGroupsApi